import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./style.css";
// لایه‌ی لوکس (هم‌زبانِ site/lux.css): بعد از style.css تا بر قاعده‌های هم‌وزن بچربد.
import "./lux.css";
import "./game/speed";   // ضریبِ سرعت را روی <html> می‌نویسد — پیش از اولین رندر
import { App } from "./ui/App";
import { loadRemote } from "./net/remote";
import { initWebAds } from "./net/ads";
import { loadTables } from "./net/tables";

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// پیکربندی **پس از** رندر و بی انتظار: صفحه‌ای که منتظرِ یک درخواستِ شبکه
// بماند تا اولین پیکسلش را بکشد، با شبکه‌ی بد اصلاً بالا نمی‌آید. هرچه پیش
// از رسیدنش خوانده شود پیش‌فرض می‌گیرد، و آن دقیقاً همان چیزی است که
// می‌خواهیم.
void loadRemote().then(initWebAds);
void loadTables();
